const PRICING_TYPE_FIXED: string = 'fixed';

export default PRICING_TYPE_FIXED;
